import { memo } from 'react';
import WhyChooseUsCard from '../../Atoms/WhyChooseUsCard/WhyChooseUsCard';
import { Carousel } from 'react-bootstrap';
import { UseSliceContentBreakpoint } from '../../../Core/Hooks/HooksGenerals/UseSliceContentBreakpoint';
import TitleYellow from '../../Atoms/TitleYellow/TitleYellow';
import { STAY_KEYS, TYPE_FETCH_PARAMETERS } from '../../../Domain/Settings/Constants/Constants';
import { COMPONENTS } from '../../../Domain/Settings/Constants/ComponentsParameter/ComponentsParameter';
import {
  useGetComponentParameters,
  useGetComponentParametersSingle,
  useGetMainComponentParameters
} from '../../../Core/Hooks/HooksParameters/useGetComponentParameters';
import useCombineArrays from '../../../Core/Hooks/HookCombineArrays/useCombineArrays';
const WhyChooseUsCardGroup = ({ parameters, isOnline, pageStay = '' }) => {
  const CRSE_WHYLT = isOnline
    ? parameters?.ALL_CRSE_WHYLT_ONLINE?.code
    : parameters?.ALL_CRSE_WHYLT?.code;

  const CRSE_WHYLT_GENERAL_MLT =
    useGetMainComponentParameters(
      COMPONENTS.WHY_CHOISE_LT_SECTION,
      TYPE_FETCH_PARAMETERS.MAIN_MULTILANGUAGE,
      CRSE_WHYLT
    ) || [];

  const CRSE_WHYLT_GENERAL_MLT_DETAIL =
    useGetComponentParametersSingle(
      COMPONENTS.WHY_CHOISE_LT_SECTION,
      TYPE_FETCH_PARAMETERS.MAIN_DETAIL,
      CRSE_WHYLT
    ) || [];

  const CRSE_WHYLT_GENERAL = useCombineArrays(
    CRSE_WHYLT_GENERAL_MLT,
    CRSE_WHYLT_GENERAL_MLT_DETAIL
  );

  const { slicedContentList } = UseSliceContentBreakpoint(
    CRSE_WHYLT_GENERAL?.length > 0 ? CRSE_WHYLT_GENERAL : []
  );

  const getTitle = (key) => {
    switch (key) {
      case STAY_KEYS.COURSE_DETAIL:
        return parameters?.WHY_LT_COURSE;

      default:
        return parameters?.WHYLT_WCL;
    }
  };

  return (
    <div className="container pt-lg-4 pt-2 pb-0">
      <TitleYellow
        className="text-center lt-text-title"
        title={getTitle(pageStay)?.value}
        titleYellow={getTitle(pageStay)?.description_value}
      />

      <Carousel controls={null} className="control-white mt-4 pt-2">
        {slicedContentList.map((content, index) => (
          <Carousel.Item key={index}>
            <div className="d-flex justify-content-center gap-3 pb-4 mb-2 w-100">
              {content?.map((props, idx) => (
                <WhyChooseUsCard key={idx} {...props} />
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
      {/* {CRSE_WHYLT_GENERAL?.map((props, index) => (
          <WhyChooseUsCard key={index} {...props} />
        ))} */}
    </div>
  );
};

export default memo(WhyChooseUsCardGroup);
